<template>
 <div class="loadingIndicator">
   <i class="fa fa-cog fa-spin"></i> {{context}}...
 </div>
</template>

<script>

export default {
  props: [
    'loadingMessage'
  ],
  computed: {
    context: function () {
      if (this.loadingMessage === undefined) {
        return 'Loading'
      } else {
        return this.loadingMessage
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style>
  .loadingIndicator {
    font-size: 1.15rem;
    color: #0056b3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue